/**
 * Keyboard shortcut notation:
 * - 'x+y'  — Hold X and Y together (simultaneous keys).
 * - 'x>y'  — Press X, then press Y (sequential keys).
 * - 'x+y>z' — Hold X and Y together, then press Z (chord followed by sequential).
 */

/** navigation shortcuts starting with 'g' */

export const GO_TO_PROJECTS_SHORTCUT = 'g > p' as const;
export const GO_TO_HOME_PAGE_SHORTCUT = 'g > h' as const;

/** legend manipulation shortcuts starting with 'l' */

export const TOGGLE_SCREENSHOT_MODE_SHORTCUT = 'l > s' as const;
export const TOGGLE_BOTTOM_ATTACHED_LEGEND_SHORTCUT = 'l > b' as const;

/** colors management shortcuts starting with 'c' */

export const SHUFFLE_COLORS_SHORTCUT = 'c > s' as const;
export const COPY_COMPARE_SELECTION_AS_QUERY_SHORTCUT = 'c > p' as const;

/** chart display shortcuts */

export const TOGGLE_ERROR_BANDS_SHORTCUT = 'c' as const;
export const TOGGLE_REFERENCE_LINES_SHORTCUT = 'r' as const;

/** miscellaneous shortcuts */

export const DISABLE_SCREENSHOT_MODE_SHORTCUT = 'Escape' as const;
export const TOGGLE_DISTRACTION_FREE_MODE_SHORTCUT = ' ' as const;
